import React, { useState, useEffect, useContext } from "react";
import SglContext from "../SglContext";
import "./billingMessages.css";
import axios from "axios";

function AgreementDetail(props) {

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('')
    const [isAgreed, setIsAgreed] = useState(false);
    const agreement = props.agreement
    const Sgl = useContext(SglContext);

    const signAgreement = async() => {
     
        setErrors('')
        if(agreement){
            setLoading(true);
            let respActionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
                action: 'Terms of Service',
                data: agreement,
                loginId: Sgl.current_user.sgl_id,
                companyId: Sgl.company_id,
                desc: 'Signing Terms of Service agreement'
            })

            
            await axios.post(`${Sgl.nestApiUrl}/billing/signAgreement`, {
                application_id: agreement.application_id,
                agreement_id: agreement.agreement_id,
                user_id: Sgl.current_user.sgl_id,
                company_id: Sgl.company_id
            }).then(async(res) => {
       
                if(res.data.success){
                    Sgl.setHasUnsignedAgreements(res?.data?.hasUnsignedAck ?? false)
                    Sgl.setUnsignedAgreements(res?.data?.agreements ?? [])
                    Sgl.getPendingUserActions()
                    if(respActionStep?.data?.sgl_id > 0){
                        await axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                            actionStepId: respActionStep?.data?.sgl_id,
                            status: 'Complete',
                            desc: 'Terms of Service agreement signed successfully',
                            error: ''
                        })
                    }
                    
                    props.handleClose()
                }else{
                    setErrors(res.data.error)
                    if(respActionStep?.data?.sgl_id > 0){
                        await axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                            actionStepId: respActionStep?.data?.sgl_id,
                            status: 'Failure',
                            desc: 'Failed to sign Terms of Service agreement',
                            error: res.data.error
                        })
                    }
                }
            });
            setLoading(false);
        }
    }

    const createTosAgreementOpenActionStep = async() => {
        await axios.get(`${Sgl.nestApiUrl}/milestone-actions/updateRequiredActionStatus`,{
            params : {
              action_id: agreement?.tosAction?.RequiredActions[0]?.sgl_id,
              status: 'In Progress'
            }
        })

        // Add action step for welcome sreen
        let actionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Terms of Service',
        data: agreement,
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Terms of Service Detail'
        });

        if (actionStep?.data?.sgl_id > 0) {
            let data = {
                actionStepId: actionStep.data.sgl_id,
                status: 'Complete',
                desc: 'Terms of Service displayed successfully (My Agreements)',
                error: ''
            };

            axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data);
        }
    }

    useEffect(() => {
        if(
            agreement.tosAgreement && 
            agreement?.tosAction?.RequiredActions?.length > 0 &&
            agreement?.tosAction?.RequiredActions[0]?.sgl_id
        ){
            createTosAgreementOpenActionStep()
        }
    }, [])

    return (
        <div className="billingMessages">
            <div className="div-responsive">
                <div className="registration-container">
                    <div className="step-header">
                        <div className="step-header-content">
                            <h2>{agreement.title}</h2>
                            <p className="step-subtitle">{agreement.description}</p>
                        </div>
                        <div className="step-header-spacer"></div>
                        </div>

                        <div className="agreement-content">
                            
                            <div className="agreement-content-header">                    
                                <div
                                    style={{
                                        padding: '5px'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: agreement?.content || '' }}
                                />
                            </div>
                        </div>

                        <div className="checkbox-group">
                            <input
                            type="checkbox"
                            id="acknowledgement-checkbox"
                            checked={isAgreed}
                            onChange={(e) => setIsAgreed(e.target.checked)}
                            disabled={loading}
                            />
                            <label htmlFor="acknowledgement-checkbox" className="checkbox-label">
                                By using the ShowGrounds Service, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
                            </label>
                        </div>

                        {
                            errors && errors != '' ?
                            <div className="error_summary">
                            { errors }
                            </div>
                            : null
                        }

                        <div className="billingMessages verification-row">
                            <span
                                onClick={() => props.closeAgreementDetailWithoutUpdate()}
                                className="radio-text-start"
                            >
                                Sign Later
                            </span>

                            <div className="agreement-detail-buttons">
                                <div className="submit">
                                    <button 
                                        className={`button primary-button ${!isAgreed ? 'disabled' : loading ? 'loading' : ''}`}
                                        onClick={() => signAgreement()}
                                        disabled={!isAgreed || loading}
                                    >
                                        <span className="btn-text">I Agree</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
}

export default AgreementDetail;